import { Api } from './Api'

class Login {
  post (params) {
    let body = {}
    if (params.preview === '1') {
      body = {
        id: params.customerId,
        code: params.code,
        data: {
          ocr: params.ocr,
          preview: 1
        }
      }
    } else {
      body = {
        id: params.customerId,
        code: params.code,
        data: {
          ocr: params.ocr
        }
      }
    }

    return fetch(`${Api.getBaseUrl()}login/`, Api.getOptions('POST', body))
  }

  get () {
    return fetch(`${Api.getBaseUrl()}login/`, Api.getOptions())
  }
}

export default Login
